import React from 'react';
import { Container, Row, Col, Button, Carousel } from 'react-bootstrap';
import { BsGithub, BsArrowLeft, BsArrowRight } from 'react-icons/bs';
import { useLocation } from 'react-router-dom';
import Particle from '../Particle';
import './ProjectDetail.css';

function ProjectDetail() {
  const location = useLocation();

  if (!location.state) {
    return (
      <Container fluid className="project-section">
        <Particle />
        <Container>
          <h1 className="project-heading">No project data found</h1>
          <Button variant="primary" onClick={() => window.history.back()}>
            <BsArrowLeft /> Back
          </Button>
        </Container>
      </Container>
    );
  }

  const {
    title,
    description,
    imgPath,
    ghLink,
    screenshots = [],
    techStack = [],
  } = location.state;

  return (
    <Container fluid className="project-section" id="project-detail">
      <Particle />
      <Container>
        <Button
          variant="primary"
          onClick={() => window.history.back()}
          style={{ marginBottom: '20px' }}
        >
          <BsArrowLeft /> Back
        </Button>

        <Row style={{ justifyContent: 'center' }}>
          <Col md={8}>
            <div className="project-detail-card">
              <img
                src={imgPath}
                alt={title}
                className="project-detail-img"
              />

              <h1 className="project-heading" style={{ marginTop: '30px' }}>
                {title}
              </h1>

              {techStack.length > 0 && (
                <div className="tech-stack-badges" style={{ margin: '20px 0' }}>
                  {techStack.map((tech, i) => (
                    <span key={i} className="tech-badge">{tech}</span>
                  ))}
                </div>
              )}

              <p className="project-description" style={{ color: 'white', textAlign: 'justify', marginTop: '20px' }}>
                {description}
              </p>

              {ghLink && (
                <Button
                  variant="primary"
                  href={ghLink}
                  target="_blank"
                  style={{ marginTop: '20px', minWidth: '150px' }}
                >
                  <BsGithub /> GitHub
                </Button>
              )}

              {!ghLink && (
                <Button
                  variant="secondary"
                  disabled
                  style={{ marginTop: '20px', minWidth: '150px' }}
                >
                  <BsGithub /> Confidential
                </Button>
              )}
            </div>
          </Col>

          {screenshots.length > 0 && (
            <Col md={12} style={{ marginTop: '50px' }}>
              <h2 className="project-heading" style={{ fontSize: '1.8rem' }}>
                Screenshots
              </h2>
              <Carousel
                fade
                indicators={screenshots.length > 1}
                controls={screenshots.length > 1}
                prevIcon={<BsArrowLeft size={30} />}
                nextIcon={<BsArrowRight size={30} />}
              >
                {screenshots.map((src, i) => (
                  <Carousel.Item key={i}>
                    <div className="carousel-image-wrapper">
                      <img src={src} alt={`Screenshot ${i + 1}`} />
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            </Col>
          )}
        </Row>
      </Container>
    </Container>
  );
}

export default ProjectDetail;
